import { PatientGroupAssignmentQuery } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCount } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';
import { commonTranslationKeys } from '@dreryk/react-common';

type CustomPatientGroupsRemoveModalLoaderRenderProps = {
   numberAssignedPatients: number;
};

type CustomPatientGroupsRemoveModalLoaderProps = {
   children: (renderProps: CustomPatientGroupsRemoveModalLoaderRenderProps) => JSX.Element;
   patientGroupId: number;
};

export const CustomPatientGroupsRemoveModalLoader = (props: CustomPatientGroupsRemoveModalLoaderProps): JSX.Element => {
   const {
      data: patientsGroupAssignmentCount,
      error: patientsGroupAssignmentCountError,
      loading: patientsGroupAssignmentCountLoading,
   } = useCqrsCount(() => {
      const query = new PatientGroupAssignmentQuery();
      query.patientGroupId = Slot.of(props.patientGroupId);
      return query;
   });

   if (patientsGroupAssignmentCountLoading) {
      return <LoaderSpinner />;
   }

   if (patientsGroupAssignmentCountError) {
      return (
         <Message
            testId={'patientGroupAssignmentFetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({ numberAssignedPatients: patientsGroupAssignmentCount });
};
